module.exports = function(successCallback, errorCallback) {
	require.ensure([], function() {
		successCallback(require("!!../../node_modules/babel-loader/lib/index.js!./CartContainer.js"));
	}, function() {
		if (errorCallback) errorCallback.apply(this, arguments);
	});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/split-chunk-loader?lazy!./src/Checkout/CartContainer.js
// module id = 1154
// module chunks = 58